'use client';

import { getLS, setLS } from '@/service/storage/LocalStorage';
import { useEffect, useState } from 'react';

const DARK = 'dark';
const LIGHT = 'light';
const LS_THEME = 'theme';

const isDarkTheme = () => getLS(LS_THEME) === DARK;

export const ToggleTheme = () => {
    const [theme, setTheme] = useState<'dark' | 'light'>();
    const isDark = theme === DARK;

    const onToggle = () => {
        if (isDarkTheme()) {
            document.documentElement.classList.remove(DARK);
            setLS(LS_THEME, LIGHT);
            setTheme(LIGHT);
        } else {
            document.documentElement.classList.add(DARK);
            setLS(LS_THEME, DARK);
            setTheme(DARK);
        }
    };

    useEffect(() => {
        if (isDarkTheme()) {
            setTheme(DARK);
        } else {
            setTheme(LIGHT);
        }
    }, []);

    return (
        <div
            className="tx-large-regular flex cursor-pointer items-center py-5 text-gray-1 dark:text-white"
            onClick={onToggle}
            data-test-id="toggle-theme-btn"
        >
            Dark mode:&nbsp;
            {isDark ? 'on' : 'off'}&nbsp;
            <div className="ml-[10px] flex h-[26px] w-12 justify-start rounded-3xl bg-gray-4 dark:justify-end dark:bg-brand">
                {
                    <img
                        src={isDark ? '/icon/Moon.svg' : '/icon/Sun.svg'}
                        alt="Change theme"
                        className="m-[2px] h-[22px] w-[22px] rounded-full bg-white p-1"
                    />
                }
            </div>
        </div>
    );
};
